import React from 'react'
import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import './InputSwitch.scss'

interface InputSwitchProps {
  value?: boolean
  onChange?: (value: boolean) => void
  disabled?: boolean
  title?: string
  hint?: string
  horizontal?: boolean
  removable?: boolean
  onRemove?: () => void
  id?: string
}

export const InputSwitch: React.FC<InputSwitchProps> = ({
  value = false,
  onChange,
  disabled = false,
  title,
  hint,
  horizontal = false,
  removable = false,
  onRemove,
  id,
}) => {
  const { t } = useTranslation()
  const switchId = id || `switch-${Math.random().toString(36).substr(2, 9)}`

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.checked)
  }

  return (
    <div className="mb-3">
      <div className="row">
        {!horizontal && (
          <div className="d-flex align-items-center position-relative hidden-button-container col-md-3">
            {title && (
              <label className="form-label" htmlFor={switchId}>
                {title}
              </label>
            )}
            {removable && (
              <button type="button" className="btn btn-sm btn-danger position-absolute left-0" onClick={onRemove}>
                <i className="bi bi-x"></i>&nbsp;{t('remove')}
              </button>
            )}
          </div>
        )}
        <div className={horizontal ? 'align-items-center d-flex' : ''}>
          <div className="form-check form-switch">
            <Form.Check type="switch" id={switchId} checked={value} onChange={handleChange} disabled={disabled} />
            {horizontal && title && (
              <label className="form-check-label" htmlFor={switchId}>
                {title}
              </label>
            )}
            {hint && <div className="form-text text-muted">{hint}</div>}
          </div>
        </div>
      </div>
    </div>
  )
}
